import React from 'react';
import Banner from "../../Assets/Images/contactimg.webp";

const AllsecBanner = ({ title = "" }) => {
  return (
    <div 
      style={{ backgroundImage: `url(${Banner})` }} 
      className="bg-cover bg-center w-full h-[20rem] top-0 flex items-center justify-center relative"
    >
      {/* Overlay */}
      {/* <div className="absolute inset-0 bg-black/30 bg-opacity-30"></div> */}
      
      {/* Title Only - Centered */}
      <div className="relative z-10 text-center">
        <h1 className="text-3xl font-semibold text-white">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default AllsecBanner;